module.exports = __webpack_public_path__ + "img/c02-3.cd16db0c.gif";